import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DotsLoader } from 'Components/DotsLoader';

const Card = styled.div`
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const CardTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0 0 16px;
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: ${({ $active }) => $active ? 'var(--vo-success-10)' : 'var(--vo-danger-10)'};
  border-radius: 10px;
  border: 1px solid ${({ $active }) => $active ? 'var(--vo-success-20)' : 'var(--vo-danger-20)'};
`;

const IconBadge = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: ${({ $active }) => $active ? 'var(--vo-success-15)' : 'var(--vo-danger-15)'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const StatusTitle = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: ${({ $active }) => $active ? 'var(--vo-success)' : 'var(--vo-danger)'};
  margin: 0 0 2px;
`;

const StatusSub = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
  margin: 0;
`;

const VerifyBtn = styled.button`
  width: 100%;
  height: 40px;
  background: white;
  color: var(--vo-slate);
  border: 1.5px solid var(--vo-line);
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover:not(:disabled) { background: var(--vo-mist); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const CardIntegrationStatus = ({ disclaimerStatusAtivo, domain, onVerify, isVerifying }) => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card>
      <CardTitle>{t('cookies:show.integrationStatus.label')}</CardTitle>
      <StatusRow $active={disclaimerStatusAtivo}>
        <IconBadge $active={disclaimerStatusAtivo}>
          {disclaimerStatusAtivo ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--vo-success)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--vo-danger)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          )}
        </IconBadge>
        <div>
          <StatusTitle $active={disclaimerStatusAtivo}>
            {disclaimerStatusAtivo ? t('cookies:show.integrationStatus.installed') : t('cookies:show.integrationStatus.notInstalled')}
          </StatusTitle>
          <StatusSub>
            {disclaimerStatusAtivo
              ? t('cookies:show.integrationStatus.verified', { domain: domain || '' })
              : domain || ''}
          </StatusSub>
        </div>
      </StatusRow>
      <VerifyBtn onClick={onVerify} disabled={isVerifying}>
        {isVerifying ? <DotsLoader /> : t('cookies:show.integrationStatus.verifyButton')}
      </VerifyBtn>
    </Card>
  );
};
